// Libraries
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

// MUI
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

// Core
import { ResourceTextApplication } from '../../../core/resources';

// Common
import { ADialog, ADialogActions, ADialogContent, ADialogTitle } from '../../../common/dialog';
import { AnnouncementTypeEnum } from '../../../interfaces/enums';

// Interfaces
// Store
// API
// Feature

export interface ICreatePreliminaryAnnouncementDialog {
    onClose: () => any;
    onSave: (announcementType: AnnouncementTypeEnum) => Promise<void>;
}

export default function CreatePreliminaryAnnouncementDialog(
    props: ICreatePreliminaryAnnouncementDialog
) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaBovine', 'AnelmaGeneral']);
    const [loading, setLoading] = useState<boolean>(false);

    return (
        <ADialog onClose={() => props.onClose()} open={true} >
            <ADialogTitle>{t(`AnelmaBovine:1188`)}</ADialogTitle>

            <ADialogContent size='sm'>
                <Grid container style={{ paddingLeft: '24px' }}>
                    <Typography variant='body1'>{t(`AnelmaBovine:1189`)}</Typography>
                </Grid>
            </ADialogContent>

            <ADialogActions
                buttons={{
                    left: [
                        {
                            onClick: () => props.onClose(),
                            type: 'cancel',
                            disabled: loading,
                        },
                    ],
                    right: [
                        {
                            onClick: () => {
                                setLoading(true);
                                props
                                    .onSave(AnnouncementTypeEnum.PreliminaryBovineIntermediationAnnouncement)
                                    .then(() => setLoading(false));
                            },
                            type: 'save',
                            label: t(`AnelmaBovine:1190`),
                            disabled: loading,
                        },
                        {
                            onClick: () => {
                                setLoading(true);
                                props
                                    .onSave(AnnouncementTypeEnum.PreliminaryBovineSlaughterAnnouncement)
                                    .then(() => setLoading(false));
                            },
                            type: 'save',
                            label: t(`AnelmaBovine:1191`),
                            disabled: loading,
                        },
                    ],
                }}
            />
        </ADialog>
    );
}
